import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 9B1DF082-5266-408A-A057-92E9AEB81BFA
 * name post
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/post.svg
 * tags
 */
export const PostIcon = createSvgIcon(<><path d="M3 3V21H21V3H3M18 18H6V17H18V18M18 16H6V15H18V16M18 12H6V6H18V12Z" /></>, 'PostIcon');
export default PostIcon